module.exports = __webpack_public_path__ + "img/credit_cards.ba681356.png";